import C1101Const from './C1101Const'

export default C1101Const.getStore()
